import { PortfolioViewState } from 'enums/PortfolioViewState'
import { ACCOUNT_STATUS, Portfolio, PortfolioLinkType } from 'types'

import DropdownMenu from 'components/common/Dropdown/DropdownMenu'
import { MenuItem } from 'components/common/NavigationDropdownMenu/NavigationDropdownMenuItem'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import { SIZE } from 'designSystem/foundations/constants/size'
import { getPortfolioViewState } from 'utils/portfolioUtil'

type Props = {
  menuItems: MenuItem[]
  openRequestSupport: () => void
  portfolio: Portfolio
  openDeletePortfolioModal: () => void
  linkType: PortfolioLinkType
  accountStatus?: ACCOUNT_STATUS
}

export default function PortfolioHeaderSection({
  menuItems,
  openRequestSupport,
  portfolio,
  openDeletePortfolioModal,
  linkType,
  accountStatus,
}: Props) {
  const portfolioViewState = getPortfolioViewState(portfolio)
  let showDeleteButton = false

  const isIbOrPaveSecurities =
    linkType === PortfolioLinkType.InteractiveBrokers ||
    linkType === PortfolioLinkType.PaveSecurities

  // Show delete button if portfolio state is not "NORMAL"
  if (
    isIbOrPaveSecurities &&
    portfolioViewState === PortfolioViewState.PENDING
  ) {
    switch (accountStatus) {
      case ACCOUNT_STATUS.ABANDONED:
      case ACCOUNT_STATUS.REJECTED:
        showDeleteButton = true
        break
    }
  } else if (portfolioViewState !== PortfolioViewState.NORMAL) {
    showDeleteButton = true
  }

  return (
    <PDSFlexBox
      alignItems="center"
      justifyContent="space-between"
      marginY={SIZE.s32}
    >
      <PDSFlexBox alignItems="center">
        <PDSHeader variant="h1">{portfolio?.displayName ?? '-'}</PDSHeader>
        <DropdownMenu menuItems={menuItems} menuName="" />
      </PDSFlexBox>

      <PDSFlexBox flexShrink={0} flexDirection="row" gap={SIZE.s12}>
        <PDSButton
          iconLeft="support"
          onClick={openRequestSupport}
          size="sm"
          text="Request Support"
          variant="tertiary"
        />

        {showDeleteButton && (
          <PDSButton
            onClick={openDeletePortfolioModal}
            text="Delete Portfolio"
            variant="danger"
            size="sm"
          />
        )}
      </PDSFlexBox>
    </PDSFlexBox>
  )
}
